// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import CollegeLayout from './layouts/CollegeLayout';
import LoginForm from './pages/LoginForm';
import RegisterForm from './pages/RegisterForm';
import Dashboard from './pages/Dashboard';
import AlumniList from './pages/AlumniList';
import CollegeJobList from './pages/CollegeJobList';
import CreateCollegeJob from './pages/CreateJobCollege';
import CollegeJobDetails from './pages/CollegeJobDetails';
import CollegeEventList from './pages/CollegeEventList';
import CollegeEventDetails from './pages/CollegeEventDetails';
import CollegeCampaignList from './pages/CollegeCampaignList';
import CollegeCampaignDetails from './pages/CollegeCampaignDetails';
import CollegeCampaignForm from './pages/CreateCampaignCollege';
import CreateEventCollege from './pages/CreateEventCollege';
import AnalyticsAlumni from './pages/AnalyticsAlumni';
import AnalyticsEvents from './pages/AnalyticsEvents';
import AnalyticsJob from './pages/AnalyticsJob';
import AnalyticsCampaign from './pages/AnalyticsCampaign';
import CollegeProfile from './pages/CollegeProfile';
import CSVUpload from './pages/CSVUpload';
import CollegeNavbar from './components/CollegeNavbar';
import SuccessStoryList from './pages/SuccessStoryList';
import SurveyManagement from './pages/SurveyManagement';
import FeedbackManagement from './pages/FeedbackManagement';
import NewsletterEditor from './pages/NewsletterEditor';
import NewsletterList from './pages/NewsletterList';
import NewsletterDetail from './pages/NewsletterDetail';
import Attendance from './pages/Attendance';

const ProtectedRoute = () => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  if (!token || userRole !== 'college_admin') {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />

        {/* Protected College Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<CollegeLayout />}>
            <Route path="/college" element={<Navigate to="/college/dashboard" replace />} />
            <Route path="/college/dashboard" element={<Dashboard />} />
            <Route path='/college/alumni' element={<AlumniList />} />
            <Route path='/college/alumni-analytics' element={<AnalyticsAlumni />} />
            <Route path='/college/events-analytics' element={<AnalyticsEvents />} />
            <Route path='/college/job-analytics' element={<AnalyticsJob />} />
            <Route path='/college/campaigns-analytics' element={<AnalyticsCampaign />} />
            <Route path="/college/jobs" element={<CollegeJobList />} />
            <Route path="/college/jobs/create" element={<CreateCollegeJob />} />
            <Route path="/college/jobs/edit/:id" element={<CreateCollegeJob />} />
            <Route path="/college/jobs/:id" element={<CollegeJobDetails />} />
            <Route path="/college/events" element={<CollegeEventList />} />
            <Route path="/college/events/create" element={<CreateEventCollege />} />
            <Route path="/college/events/edit/:id" element={<CreateEventCollege />} />
            <Route path="/college/events/:id" element={<CollegeEventDetails />} />
            <Route path="/college/events/attendance/:id" element={<Attendance />} />
            <Route path="/college/campaigns" element={<CollegeCampaignList />} />
            <Route path="/college/campaigns/create" element={<CollegeCampaignForm />} />
            <Route path="/college/campaigns/edit/:id" element={<CollegeCampaignForm />} />
            <Route path="/college/campaigns/:id" element={<CollegeCampaignDetails />} />
            <Route path="/college/profile" element={<CollegeProfile />} />
            <Route path="/college/upload" element={<CSVUpload />} />
            <Route path="/college/successstorylist" element={<SuccessStoryList />} />
            <Route path="/college/survey" element={<SurveyManagement />} />
            <Route path="/college/feedback" element={<FeedbackManagement />} />
            <Route path="/college/newsletter/new" element={<NewsletterEditor />} />
            <Route path="/college/newsletter/new" element={<NewsletterEditor />} />
    <Route path="/college/newsletter/edit/:id" element={<NewsletterEditor />} />
    <Route path="/college/newsletters" element={<NewsletterList />} />
    <Route path="/college/newsletter/:id" element={<NewsletterDetail />} />
          </Route>
        </Route>

        {/* Default Route */}
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;